import { useSelector } from "react-redux";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
import { useSite } from "../../context/TranslationContext";
import styles from "./About.module.scss";
import { RootState } from "../../redux/store";
const About = () => {
  const { data } = useSelector((state: RootState) => state.translationData);
  return (
    <div id={styles.about_page}>
      <TitleUpdater
        title={
          data?.colibri && data?.about_us
            ? `${data.colibri} | ${data.about_us}`
            : "Colibri"
        }
      />
      <div className="container">
        <div className={styles.about}>
          <div className={styles.about_content}>
            <h1 className={styles.about_title}>{data?.about_us}</h1>
            <p
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: data?.about || "" }}
            />
          </div>
        </div>
      </div>
      <MobileAppSection />
    </div>
  );
};

export default About;
